const ItemModel = VOID.EventEmitter.extend({
  constructor(data) {
    VOID.EventEmitter.call(this);
    this.data = data;
  },

  get selected() {
    return this.data.selected;
  },

  set selected(val) {
    if (this.data.selected === val) return;
    this.data.selected = val;
    this.emit("change");
  },

  get name() { return this.data.name; },
  get alias() { return this.data.alias; },
  get id() { return this.data.id; },
  get count() { return this.data.count; }
});

const CatModel = VOID.EventEmitter.extend({
  constructor(data) {
    VOID.EventEmitter.call(this);
    this.setItems(data.items);
  },

  getItems() {
    return this.items;
  },

  getItem(id) {
    return this.itemsByID[id];
  },

  setItems(newItems) {
    if (this.items) this.items.forEach(it => { it.destroy(); });

    this.items = newItems
      .filter(it => !it.invalid)
      .map(it => {
        const model = new ItemModel(it);
        this.proxy(model);
        return model;
      });

    this.itemsByID = {};
    this.items.forEach(it => {
      this.itemsByID[it.id] = it;
    });
    this.emit("change_list");
  }
});

const FilterCatView = VOID.View.extend({
  getName: VOID.utils.constant("filter"),
  getTemplateName: VOID.utils.constant("filter"),

  init() {
    this.autocomplete = null;
    this.isExpanded = false;
    this.listenTo(this.model, "change_list", () => {
      this.handleListChange();
    });
  },

  getTemplateData() {
    return {
      placeholder: this.opts.placeholder,
      empty_msg: this.opts.emptyMessage,
      header: this.opts.header,
      expand_label: this.opts.expandLabel,
      contract_label: this.opts.contractLabel
    };
  },

  getDefaultOptions() {
    return {
      itemLimit: 5
    };
  },

  handleMounted() {
    this.autocomplete = new SelectComplete(this.references.select, {
      template: "filterAutocompleteTemplate",
      fetch: InputComplete.Static(this.getAutocompleteList()),
      onSubmit: "set",
      minCharacters: 0,
      itemLimit: this.opts.itemLimit,
      selectEl: this.references.autocomplete,
      focusAfterMouseInteraction: false,
      itemClick: false,
      enterKey: false,
      resetOnBlur: false,
      preventHover: true,
      validate: false,
      onSelect: (item, meta) => {
        if (meta.src === "keydown") {
          const $checkbox = $(this.references.autocomplete).find("[value="+item.id+"]");
          const checked = !$checkbox.prop("checked");
          $checkbox.prop("checked", checked);
          this.model.getItem(item.id).selected = checked;
        }
      },
      onUpdate: () => {
        const length = this.autocomplete.list.length;
        this.references.expand_btn.style.display = (length > this.opts.itemLimit) ? "" : "none";
        $(this.references.empty_msg).toggleClass("d-none", length > 0);
      }
    });

    this.autocomplete.fetch();

    this.references.expand_btn.addEventListener("click", () => {
      this.toggleExpanded();
    });

    this.references.autocomplete.addEventListener("change", evt => {
      const target = evt.target;
      const $target = $(target);
      if($target.hasClass("js-filter-checkbox")) {
        this.model.getItem(+target.value).selected = target.checked;
      }
    });
  },

  getAutocompleteList() {
    return this.model.getItems().map(it => ({
      text: it.alias || it.name,
      html: htmlEntities(it.name),
      id: it.id,
      name: this.opts.name,
      count: it.count,
      get checked() { return it.selected ? "checked" : ""; }
    }));
  },

  updateAutocompleteList() {
    this.autocomplete.options.fetch.setList(this.getAutocompleteList());
    this.autocomplete.fetch();
  },

  handleListChange() {
    $(this.references.el).toggleClass("d-none", this.model.getItems().length === 0);
    this.updateAutocompleteList();
  },

  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
    this.autocomplete.setItemLimit(this.isExpanded ? Infinity : this.opts.itemLimit);
    $(this.references.expand_btn)
      .toggleClass("contract", this.isExpanded)
      .toggleClass("expand", !this.isExpanded);
  }
});

function getDefaultOpts() {
  return {};
}

class MultipleFilter {
  constructor(opts) {
    this.opts = Object.assign({}, getDefaultOpts(), opts);
    this.cats = {};
  }

  addCat(opts) {
    const model = new CatModel(opts.model);
    model.on("change", () => { this.handleChange(model); });
    const el = $(opts.el).get(0);

    opts = Object.assign({}, this.getDefaultCatOpts(), opts);
    delete opts.el;

    const cat = new FilterCatView(model, opts);
    this.cats[opts.name] = cat;
    cat.appendTo(el);
  }

  handleChange(catModel) {
    AJAX.handleSubmit($(this.opts.form).get(0));
  }

  getDefaultCatOpts() {
    return {
      template: "filterTemplate"
    };
  }
}

export {MultipleFilter};
